<template>
  <!-- Floating actions wrapper -->
  <div class="fixed inset-x-0 bottom-6 z-50 pointer-events-none">
    <div class="mx-auto px-4 flex justify-end items-end">
      <!-- Chat button -->
<!--      <button-->
<!--          class="pointer-events-auto flex items-center gap-3 bg-white shadow-lg rounded-full p-1 hover:shadow-xl hover:scale-[1.1] transition"-->
<!--      >-->
<!--        <div class="relative">-->
<!--          <img-->
<!--              src="https://placehold.co/200x200"-->
<!--              alt="Chat medewerker"-->
<!--              class="w-14 h-14 rounded-full object-cover"-->
<!--          />-->
<!--          <span-->
<!--              class="absolute -top-0 -right-0 w-3 h-3 bg-green-500 rounded-full border-2 border-white"-->
<!--          ></span>-->
<!--        </div>-->
<!--      </button>-->

      <!-- Scroll to top -->
      <button
          v-show="showScrollTop"
          @click="scrollToTop"
          class="pointer-events-auto flex items-center justify-center w-12 h-12 bg-gray-700 text-white rounded rounded-md hover:scale-[1.1] transition"
          aria-label="Scroll naar boven"
      >
        <ChevronUp class="w-5 h-5" />
      </button>
    </div>
  </div>
</template>

<script setup>
import { ChevronUp } from 'lucide-vue-next'
import { onMounted, onUnmounted, ref } from 'vue'

const showScrollTop = ref(false)

const onScroll = () => {
  showScrollTop.value = window.scrollY > 300
}

const scrollToTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' })
}


onMounted(() => {
  window.addEventListener('scroll', onScroll)
})

onUnmounted(() => {
  window.removeEventListener('scroll', onScroll)
})
</script>
